export const EC_LINE001 = '/products'
export const EC_LINE002 = '/products/detail/:id'
export const EC_LINE003 = '/cart'
export const EC_LINE029_001 = '/periodic-purchase'
export const EC_LINE029_002 = '/normal-purchase'
export const EC_LINE029_003 = '/periodic-purchase?loggedIn=true'
export const EC_LINE029_004 = '/normal-purchase?loggedIn=true'
export const EC_LINE004_001 = '/periodic-purchase/confirm'
export const EC_LINE005_001 = '/periodic-purchase/complete'
export const EC_LINE004_002 = '/normal-purchase/confirm'
export const EC_LINE005_002 = '/normal-purchase/complete'
// export const EC_LINE004 = '/cart/:type/confirm'
// export const EC_LINE005 = '/cart/:type/complete'
export const EC_LINE009 = '/mypage'
export const EC_LINE010 = '/mypage/customer'
export const EC_LINE027 = '/mypage/addresses'
export const EC_LINE011_NEW = '/mypage/addresses/new'
export const EC_LINE011_UPDATE = '/mypage/addresses/:id/edit'
export const EC_LINE012 = '/mypage/payments'
export const EC_LINE013_NEW = '/mypage/payments/new'
export const EC_LINE013_EDIT = '/mypage/payments/:id/edit'
export const EC_LINE014 = '/mypage/subscriptions'
export const EC_LINE015 = '/mypage/subscriptions/:id/edit'
export const EC_LINE016 = '/mypage/products'
export const EC_LINE017 = '/mypage/products/detail/:id'
export const EC_LINE028 = '/mypage/subscriptions/:id/confirm'
export const EC_LINE018 = '/mypage/history'
// export const EC_LINE020_021_022 = '/help/qa'
export const EC_LINE020 = '/contact'
export const EC_LINE021 = '/contact/confirm'
export const EC_LINE022 = '/contact/complete'
export const EC_LINE023 = '/contents/faq'
export const EC_LINE026 = '/contents/company'
export const EC_LINE024 = '/contents/defrayal'
export const EC_LINE025 = '/contents/privacy'
export const EC_LINE030 = '/help/terms-of-use'
export const EC_LINE031 = '/login'
export const EC_LINE032 = '/forget'
export const EC_LINE033 = '/forget/complete'
export const EC_LINE034 = '/passreset'
export const EC_LINE035 = '/passreset/complete'
export const EC_LINE036 = '/line-contact'
export const EC_LINE037 = '/line-contact/completed'
export const EC_LINE038 = '/contents/customer-rank'
export const CALLBACK = '/callback'
export const REDIRECT_AMAZON = '/redirect/amazon'
export const EC_LINE039 = '/line-link'
export const EC_LINE040 = '/line-link/confirm'
export const LINE_SUBSCRIBE = '/line-subscribe'
export const EC_LINE041 = '/supplier/apply'
export const EC_LINE042 = '/mypage/purchases'
export const PAGE_NOT_FOUND = '/page-not-found'
